import { Component, Input } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'

import { BranchStatus } from '../../models/branch.model'
import { TagComponent } from '../tag/tag.component'

@Component({
  selector: 'app-branch-status',
  imports: [TagComponent, TranslatePipe],
  templateUrl: './branch-status.component.html',
})
export class BranchStatusComponent {
  @Input({ required: true }) public status!: BranchStatus
}
